import { useState } from 'react'

import UKFlag from '../../Resources/languages/en.png'
import ITFlag from '../../Resources/languages/it.png'

const options = [
  { value: 'IT', label: 'IT', icon: ITFlag },
  { value: 'EN', label: 'EN', icon: UKFlag }
]

/**
 * Selettore lingua nella topbar, allineato al design system Nora
 * @param {Object} props
 * @param {string} props.value - Codice lingua selezionata (IT/EN)
 * @param {Function} props.onChange - Callback per cambio lingua
 * @returns {JSX.Element}
 */
const LanguageSelector = ({ value, onChange }) => {
  const [open, setOpen] = useState(false)

  const selectedOption = options.find((opt) => opt.value === value) || options[0]

  return (
    <div style={{ position: 'relative' }}>
      <button
        type="button"
        className="nora-lang"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-haspopup="listbox"
      >
        <img
          src={selectedOption.icon}
          alt={selectedOption.label}
          className="nora-lang-option__flag"
        />
        {selectedOption.label}
        <svg
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          style={{ color: 'var(--ink-500)' }}
        >
          <path
            d="M1 1L5 5L9 1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {open && (
        <>
          <div className="nora-lang-backdrop" onClick={() => setOpen(false)} aria-hidden="true" />
          <div className="nora-lang-menu" role="listbox">
            {options.map((option) => (
              <button
                key={option.value}
                type="button"
                role="option"
                aria-selected={option.value === value}
                className={`nora-lang-option${option.value === value ? ' is-selected' : ''}`}
                onClick={() => {
                  onChange(option.value)
                  setOpen(false)
                }}
              >
                <img src={option.icon} alt={option.label} className="nora-lang-option__flag" />
                {option.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default LanguageSelector
